const selectInitialState = {
  segment: null,
};

const select = (state = selectInitialState, action) => {
  switch (action.type) {
    case 'SELECT_SEGMENT':
    case 'UPDATE_SEGMENT_SUCCESS':
      return {
        ...state,
        segment: action.segment,
      };

    case 'DELETE_SEGMENT_SUCCESS':
      return {
        ...state,
        segment: null,
      };

    default:
      return state;
  }
};

export default select;

export const getSelected = (state) => state.segment;
